/* @jsxImportSource @emotion/react */
import React from 'react'
import { css } from '@emotion/react'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'

import { CustomerLogoBanner } from '@slite/components'

import { Button } from '../../components/Button/Button'
import { Section } from '../../components/Section'
import { useRoutes } from '../../routes'

const HERO_VIDEO_URL =
  'https://cdn.sanity.io/media-libraries/mlPfCokLiZ8K/files/containers/3954GsbfUdFng0aPimVzjyGmKh2/super-hero-video-thumbnail.mp4'

export function SectionAiSearchHero() {
  const routes = useRoutes()

  return (
    <Section
      isFirstSection
      containerTopPadding={120}
      containerBottomPadding={80}
      background="moon-dust-lighter"
      className="position-relative"
    >
      <div
        className={classNames(
          'flexbox flexbox-column flexbox-align-center text-align-center',
          'margin-left-auto margin-right-auto'
        )}
        style={{ maxWidth: 880 }}
      >
        <h1
          className="font-family-title font-size-1 line-height-normal font-weight-medium shade-05"
          css={css`
            letter-spacing: -0.02em;
          `}
        >
          <FormattedMessage
            id="aiSearch.hero.title"
            defaultMessage="AI search and agents, across all your company tools"
          />
        </h1>
        <p
          className="font-size-4 line-height-large margin-top-16 shade-10"
          style={{ maxWidth: 640 }}
        >
          <FormattedMessage
            id="aiSearch.hero.subtitle"
            defaultMessage="Give your team instant answers and power your custom agents from Slack, Notion, Google Drive, Jira, and 20+ sources — with citations you can trust."
          />
        </p>

        <div className="margin-top-32 flexbox flexbox-centered flexbox-gap-12 flexbox-wrap">
          <Button
            variant="primary-brand"
            size="default"
            href={routes.bookDemo()}
          >
            <FormattedMessage
              id="aiSearch.hero.cta.demo"
              defaultMessage="Book a demo"
            />
          </Button>
          <Button
            variant="secondary"
            size="default"
            href={routes.auth.signup()}
          >
            <FormattedMessage
              id="aiSearch.hero.cta.try"
              defaultMessage="Get free trial"
            />
          </Button>
        </div>
      </div>

      <div className="margin-top-60 position-relative">
        <video
          src={HERO_VIDEO_URL}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          className="width-full radius-larger overflow-hidden"
          style={{
            display: 'block',
            margin: '0 auto',
            maxWidth: 1100,
            border: '1px solid var(--alpha-shade-15)',
          }}
        />
      </div>

      <div className="margin-top-60 text-align-center">
        <p className="font-size-5 shade-20 margin-bottom-16">
          <FormattedMessage
            id="aiSearch.hero.customers"
            defaultMessage="Trusted by 3,000+ teams as their company brain"
          />
        </p>
        <CustomerLogoBanner
          containerClass="margin-top-12"
          showEdgeFade={false}
        />
      </div>
    </Section>
  )
}
